import styled  from 'styled-components';
import { LayoutConst } from 'core';
import { IconWrapper } from 'shared/assets/styles';

export const ShareButtonWrapper = styled.div`

  #tippy-7 { // центруем попал likes контроллера
    left: 2.5px !important; 
  }
  &:not(:last-child) {
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 16px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 0;
      ${IconWrapper} {
        margin-top: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
     svg {
        top: -8px;
    }
  }
`;import styled  from 'styled-components';
import { LayoutConst } from 'core';
import { IconWrapper } from 'shared/assets/styles';

export const ShareButtonWrapper = styled.div`

  #tippy-7 { // центруем попал likes контроллера
    left: 2.5px !important; 
  }
  &:not(:last-child) {
    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 16px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 0;
      ${IconWrapper} {
        margin-top: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: 0;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
     svg {
        top: -8px;
    }
  }
`;